import { type WithIdProps, withId } from "@components/HOC/with-id/withId";
import { PageClientCreditAccounts } from "@components/modules/clients/credit-accounts/PageClientCreditAccounts";
import { NavigationClient } from "@components/widgets/AppSubNav";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import { createFileRoute } from "@tanstack/react-router";

const Page = ({ id }: WithIdProps) => (
  <MainLayout
    title={t`Client credit accounts`}
    navigation={<NavigationClient id={id} variant="panel" />}
  >
    <PageClientCreditAccounts />
  </MainLayout>
);
const RouteComponent = withId(Page);

export const Route = createFileRoute("/clients/credit-accounts")({
  component: RouteComponent,
});
